/* eslint-disable react/no-direct-mutation-state */
import React, { Component } from 'react';
import axios from 'axios';


class Blog extends Component {
    state = {
        data: [],
        data1:[],
        data2:[],
        uimg: [],
        uimg1:[],
        uimg2:[]
    }
    
    componentDidMount() {
   

        axios.get('https://blog.aiplexantipiracy.com/wp-json/wp/v2/posts?filter[orderby]=date&order=desc').then(res => {
            console.log(res.data[1].excerpt.rendered)
            console.log(res.data[1].featured_media)
            console.log(res.data[1].title.rendered)
            console.log(res.data[1].date)
            console.log(res.data[1].link)
            this.setState({ data2: res.data })
            this.state.data2.slice(0,3).forEach((media, index) => {
                // console.log(media)
                let url = "https://blog.aiplexantipiracy.com/wp-json/wp/v2/media/" + media.featured_media;
                // console.log("URL", url)
                axios.get(url).then(res => {
                    // console.log(res.data.source_url)
                    let imgurl = (this.state.data2[index].imgurl = res.data.source_url);
                    this.setState({ uimg2: imgurl });

                    // console.log("umage", this.state.uimg)
                    // console.log(this.state.data[0].title.rendered)
                })
            })
        })
    }

    render() {
        


        const blog2 = this.state.data2.slice(0, 3).map((blogdata, index) => {
            let body = blogdata.excerpt.rendered
            body = body.slice(3, -5)
            // body = body + "..."
            let date = blogdata.date
            date = date.slice(0, 10)
                              // full date start
                              var mdate = new Date(date).toDateString();
                              var mnth = new Date(date).toLocaleString('default', { month: 'long' })
            return (

                <div className="col-md-4 px-4 blogmain ">
                    <a href={blogdata.link} target="_blank" style={{ textDecoration: "none", color: "black" }} rel="noreferrer">
                        <div className="row  blogheight" style={{ overflow: "hidden"}}>
                            <p className="bloghead">{blogdata.title.rendered}</p>
                        </div>
                        <div className="row  ">

                        <div className="imgdiv">
                        <div className='col-12 px-0'>
                            <div className="neapolitanx"></div>   
                            </div> 
                            <img loading="lazy" alt="blog" src={this.state.data2[index].imgurl} className="blogimg" title="blog" />
                            
                            </div>  
                            
                                          
                            <div className="row mx-0 pt-3" style={{width:'100%'}}>
                            <p className=" p16 pt-2 ml-2 mr-auto"><strong >{mnth} {mdate.slice(8,10)},{mdate.slice(10,)}</strong></p>
                            </div>                            
                            <p className="p16  btext" >{body}</p>
                            <div className="row mx-0 pb-4" style={{width:'100%'}}>
                            <a  href={blogdata.link} className="p16 mr-2 apl ml-auto"><strong > <span className="first-latter" >R</span>ead More</strong> <i className="fa fa-angle-double-right ml-2" aria-hidden="true"></i></a>
                            </div>  
                            <div className='col-12 px-0'>
                            <div className="neapolitany"></div>   
                            </div> 
                        </div>
                    </a>
                </div>

            );


        })


        return (
            <div  className="row blogpt">
                    {blog2}
                        
                    </div>
        );
    }
}

export default Blog;